import StatusBadge from "../StatusBadge/StatusBadge";
import { SelectItem } from "./EntrySelectItem.styled";
import useNonMaritime from "../../../hooks/useNonMaritime";

interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
  label: string;
  status: number;
  autosave: number;
  value: string;
}

export const EntrySelectItem = ({
  label,
  status,
  autosave,
  value,
}: ItemProps) => (
  <SelectItem>
    {label}
    <StatusBadge id={value} status={status} size={"sm"} autosave={autosave} />
  </SelectItem>
);

export const EntrySelectItemWidget = ({ label }: ItemProps) => (
  <SelectItem>{label}</SelectItem>
);
